import { useEffect, useState } from 'react'

import { ParamsRequest } from 'Services/__shared/types/resquest'

import { ExportItems } from './../Types/ExportParamsRequest'

export const useExportReport = {
  convertColumnToItemsList: (columns: any) => {
    const exportFields: ExportItems[] = []

    columns.map((column: any) => {
      exportFields.push({
        field: String(column.key),
        label: String(column.title),
      })
    })

    return exportFields
  },

  exportXLSX: async (
    functionExport: any,
    fileName: string,
    columns: any,
    filter?: any,
    queryParams?: ParamsRequest,
  ) => {
    const exportFields: ExportItems[] = []

    columns.map((column: any) => {
      exportFields.push({
        field: String(column.key),
        label: String(column.title),
      })
    })

    const { data } = await functionExport(filter, queryParams, exportFields)

    if (data) {
      const a: any = document.createElement('A')
      a.href =
        'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; base64,' +
        data
      a.download = fileName + '.xlsx'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  },
}
